"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricerError = void 0;
var PricerError;
(function (PricerError) {
    PricerError["NO_SIZE_TIER_MATCH"] = "NO_SIZE_TIER_MATCH";
    PricerError["INVALID_PRODUCT_STATE"] = "INVALID_PRODUCT_STATE";
    PricerError["MISSING_STORAGE_FEE_SPECS"] = "MISSING_STORAGE_FEE_SPECS";
    PricerError["MISSING_REMOVAL_FEE_SPECS"] = "MISSING_REMOVAL_FEE_SPECS";
    PricerError["INVALID_REMOVAL_TYPE"] = "INVALID_REMOVAL_TYPE";
    PricerError["MISSING_COUNTRY_CODE"] = "MISSING_COUNTRY_CODE";
    PricerError["MISSING_WEIGHT_DIMENSION"] = "MISSING_WEIGHT_DIMENSION";
})(PricerError = exports.PricerError || (exports.PricerError = {}));
//# sourceMappingURL=PricerError.js.map